<div class="colorPicker_wrapper">
  <color-circle
    [color]="currentColor"
    class="colorPicker_circles"
    [colors]="colors"
    (onChangeComplete)="changeComplete($event)"
    data-testId="color-picker"
  ></color-circle>
</div>
